import React from 'react';
import BaseLayout from '@/components/layouts/BaseLayout';
import BasePage from '@/components/BasePage';
import BasicVaccineLink from '@/Handlers/BasicVaccineLink';
import BasicLink from '@/Handlers/BasicLink';
import { Container, Table } from 'reactstrap';
import Booking from '@/components/Booking';
// Translation Higher Order Component
import { translate } from 'react-switch-lang';

const Prices = ({ t }) => {
	return (
		//React.Fragment is used instead of <div className="mx-1"> or <> to hide it from source
		<React.Fragment>
			<BaseLayout
				className='cover'
				title={t('prices.title')}
				description={t('prices.text3')}
				keywords={`${t('SEO.keywords_common')} ${t('SEO.keywords_prices')}`}
				canonical='/prices'
			>
				{/* Base Page - Shared component with Container */}
				<BasePage id='prices-page' className='prices-page' role='article'>
					<Container>
						<article>
							<h2 className='page_text font-weight-bold'>{t('prices.title')}</h2>
							<hr className='vaccination-page_hr' />
							<p>
								<strong>{t('prices.text1')}</strong>
								{t('prices.text2')}
							</p>
							<br />
							<h3 className='page_subtext text-uppercase'>{t('prices.title1')}</h3>
							<p>{t('prices.text3')}</p>
							<br />
							<div className='shadow_box'>{t('prices.text4')}</div>
							<br />
							<br />
							<h3 className='page_subtext text-uppercase'>{t('prices.title2')}</h3>
							<span>{t('prices.text5')}</span>
							<br />
							{/* <div className="shadow_box">{t('prices.text6')}</div> */}
							<p />
							<br />
							<p>
								{t('prices.text7')}
								<br />
								<br />
								<em>
									{t('prices.text8')}
									{new Date().getFullYear()}.
								</em>
								<br />
								<strong>{t('prices.text9')}</strong>
							</p>
							<br />
							<Booking />

							<Table responsive striped>
								<thead className='page_subtext text-uppercase'>
									<tr>
										<td>{t('prices.table.title')}</td>
										<td>{t('prices.table.title1')}</td>
										<td>{t('prices.table.title2')}</td>
										<td>{t('prices.table.title3')}</td>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={t('vaccines.tbe.title')}
												vaccine='tbe'
												what_is={4}
												can_be_vaccinated={3}
												protection={2}
												occurrence={1}
												source={1}
											/>
										</td>
										<td>
											<span>470 DKK</span>
										</td>
										<td>x3</td>
										<td>3 {t('prices.table.years')}</td>
									</tr>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={t('vaccines.diphtheria.title')}
												vaccine='diphtheria'
												what_is={3}
												can_be_vaccinated={3}
												protection={1}
												source={1}
												kids={true}
											/>
										</td>
										<td>
											<span>285 DKK</span>
										</td>
										<td>x1</td>
										<td>10 {t('prices.table.years')}</td>
									</tr>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={t('vaccines.tetanus.title')}
												vaccine='tetanus'
												what_is={1}
												can_be_vaccinated={4}
												protection={1}
												occurrence={1}
												source={1}
												kids={true}
											/>
										</td>
										<td>
											<span>285 DKK</span>
										</td>
										<td>x1</td>
										<td>10 {t('prices.table.years')}</td>
									</tr>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={t('vaccines.yellow_fever.title')}
												vaccine='yellow_fever'
												what_is={1}
												can_be_vaccinated={7}
												protection={1}
												occurrence={1}
												source={1}
											/>
										</td>
										<td>
											<span> 680 DKK</span>
										</td>
										<td>x1</td>
										<td>{t('prices.table.lifelong')}</td>
									</tr>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={t('vaccines.hepatitis_a.title')}
												vaccine='hepatitis_a'
												what_is={3}
												can_be_vaccinated={5}
												protection={1}
												occurrence={2}
												source={2}
												kids={true}
											/>
										</td>
										<td>
											<span>600 DKK</span>
										</td>
										<td>x2</td>
										<td>40 {t('prices.table.years')}</td>
									</tr>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={`${t('vaccines.hepatitis_a.title')} ${t('prices.table.text')}`}
												vaccine='hepatitis_a'
												what_is={3}
												can_be_vaccinated={5}
												protection={1}
												occurrence={2}
												source={2}
												kids={true}
											/>
										</td>
										<td>
											<span>475 DKK</span>
										</td>
										<td>x2</td>
										<td>40 {t('prices.table.years')}</td>
									</tr>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={t('vaccines.hepatitis_b.title')}
												vaccine='hepatitis_b'
												what_is={10}
												can_be_vaccinated={3}
												occurrence={2}
												source={7}
												kids={true}
											/>
										</td>
										<td>
											<span>520 DKK</span>
										</td>
										<td>x3</td>
										<td>{t('prices.table.lifelong')}</td>
									</tr>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={`${t('vaccines.hepatitis_b.title')} ${t('prices.table.text')}`}
												vaccine='hepatitis_b'
												what_is={10}
												can_be_vaccinated={3}
												occurrence={2}
												source={7}
												kids={true}
											/>
										</td>
										<td>
											<span>435 DKK</span>
										</td>
										<td>x2</td>
										<td>40 {t('prices.table.years')}</td>
									</tr>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={`${t('vaccines.hepatitis_a.title')}+ B (TWIN)`}
												vaccine='hepatitis_a'
												what_is={3}
												can_be_vaccinated={5}
												protection={1}
												occurrence={2}
												source={2}
												kids={true}
											/>
										</td>
										<td>
											<span>750 DKK</span>
										</td>
										<td>x3</td>
										<td>40 {t('prices.table.years')}</td>
									</tr>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={`${t('vaccines.flu.title')} ${t('vaccines.flu.when')}`}
												vaccine='flu'
												what_is={4}
												can_be_vaccinated={4}
												protection={1}
												occurrence={2}
												source={1}
											/>
										</td>
										<td>
											<span>200 DKK</span>
										</td>
										<td>x1</td>
										<td>1 {t('vaccines.kids.table_year')}</td>
									</tr>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={t('vaccines.japanese_brain_inflammation.title')}
												vaccine='japanese_brain_inflammation'
												what_is={2}
												can_be_vaccinated={2}
												protection={1}
												occurrence={1}
												source={1}
												kids={true}
											/>
										</td>
										<td>
											<span>1280 DKK</span>
										</td>
										<td>x2-3</td>
										<td>
											1 {t('vaccines.kids.table_year')}, 10 {t('prices.table.years')}{' '}
											{t('prices.table.revacination')}
										</td>
									</tr>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={`${t('vaccines.cholera.title')} ${t('prices.table.text1')}`}
												vaccine='cholera'
												what_is={1}
												can_be_vaccinated={1}
												protection={1}
												occurrence={1}
												source={3}
											/>
										</td>
										<td>
											<span>2x 305 DKK</span>
										</td>
										<td>x2</td>
										<td>2 {t('prices.table.years')}</td>
									</tr>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title='MENINGITIS (ACWY)'
												vaccine='meningococcal_diseases'
												what_is={1}
												can_be_vaccinated={5}
												occurrence={1}
												source={1}
											/>
										</td>
										<td>
											<span>755 DKK</span>
										</td>
										<td>x1</td>
										<td>5 {t('prices.table.years')}</td>
									</tr>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={`${t('vaccines.polio.title')} (Boost)`}
												vaccine='polio'
												what_is={2}
												can_be_vaccinated={3}
												occurrence={1}
												source={1}
												kids={true}
											/>
										</td>
										<td>
											<span>330 DKK</span>
										</td>
										<td>x1</td>
										<td>{t('prices.table.lifelong')}</td>
									</tr>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={t('vaccines.rabies.title')}
												vaccine='rabies'
												what_is={2}
												can_be_vaccinated={6}
												protection={3}
												occurrence={1}
												source={1}
											/>
										</td>
										<td>
											<span>920 DKK</span>
										</td>
										<td>x2</td>
										<td>{t('prices.table.lifelong')}</td>
									</tr>

									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={t('vaccines.typhoid.title')}
												vaccine='typhoid'
												what_is={1}
												can_be_vaccinated={3}
												protection={1}
												occurrence={1}
												source={2}
											/>
										</td>
										<td>
											<span>530 DKK</span>
										</td>
										<td>x1</td>
										<td>3 {t('prices.table.years')}</td>
									</tr>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={`${t('vaccines.typhoid.title')} ${t('prices.table.text3')}`}
												vaccine='typhoid'
												what_is={1}
												can_be_vaccinated={3}
												protection={1}
												occurrence={1}
												source={2}
											/>
										</td>
										<td>
											<span>400 DKK</span>
										</td>
										<td>x3</td>
										<td>3 {t('prices.table.years')}</td>
									</tr>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={t('vaccines.shingrix.title')}
												vaccine='shingrix'
												what_is={1}
												can_be_vaccinated={3}
												protection={1}
												occurrence={1}
												source={2}
											/>
										</td>
										<td>
											<span>1500 DKK</span>
										</td>
										<td>x2</td>
										<td>7-10 {t('prices.table.years')}</td>
									</tr>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={t('vaccines.qdenga.title')}
												vaccine='qdenga'
												what_is={1}
												can_be_vaccinated={3}
												protection={1}
												occurrence={1}
												source={2}
											/>
										</td>
										<td>
											<span>950 DKK</span>
										</td>
										<td>x2</td>
										<td>0-3 {t('prices.table.months')}</td>
									</tr>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={t('vaccines.diphtheria.title')}
												vaccine='diphtheria'
												what_is={3}
												can_be_vaccinated={3}
												protection={1}
												source={1}
												kids={true}
											/>
										</td>
										<td>
											<span>450 DKK</span>
										</td>
										<td>x1</td>
										<td>10 {t('prices.table.years')}</td>
									</tr>

									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={t('vaccines.whooppling_cough.title')}
												vaccine='whooppling_cough'
												what_is={3}
												can_be_vaccinated={2}
												protection={1}
												source={1}
											/>
										</td>
										<td>
											<span>450 DKK</span>
										</td>
										<td>x1</td>
										<td>10 {t('prices.table.years')}</td>
									</tr>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={t('prices.table.text4')}
												vaccine='hpv'
												what_is={2}
												can_be_vaccinated={2}
												protection={2}
												occurrence={1}
												source={1}
												kids={true}
											/>
										</td>
										<td>
											<span>1900 DKK</span>
										</td>
										<td>x2-3</td>
										<td>{t('prices.table.lifelong')}</td>
									</tr>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={`${t('prices.table.text5')} (Pneumovax)`}
												vaccine='pneumococcal_diseases'
												what_is={1}
												can_be_vaccinated={3}
												occurrence={1}
												source={1}
												kids={true}
											/>
										</td>
										<td>
											<span>550 DKK</span>
										</td>
										<td>x1</td>
										<td>5 {t('prices.table.years')}</td>
									</tr>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={`${t('prices.table.text5')} (Prevenar 13)`}
												vaccine='pneumococcal_diseases'
												what_is={1}
												can_be_vaccinated={3}
												occurrence={1}
												source={1}
												kids={true}
											/>
										</td>
										<td>
											<span>950 DKK</span>
										</td>
										<td>x1</td>
										<td>{t('prices.table.lifelong')}</td>
									</tr>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={t('vaccines.prevenar20.title')}
												vaccine='prevenar20'
												what_is={1}
												can_be_vaccinated={3}
												protection={1}
												occurrence={1}
												source={2}
											/>
										</td>
										<td>
											<span>1600 DKK</span>
										</td>
										<td>x1</td>
										<td>{t('prices.table.lifelong')}</td>
									</tr>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title='MENINGITIS (B)'
												vaccine='meningococcal_diseases'
												what_is={1}
												can_be_vaccinated={5}
												occurrence={1}
												source={1}
											/>
										</td>
										<td>
											<span>1100 DKK</span>
										</td>
										<td>x2-3</td>
										<td>5 {t('prices.table.years')}</td>
									</tr>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={t('vaccines.measels.title')}
												vaccine='measels'
												what_is={3}
												can_be_vaccinated={3}
												occurrence={2}
												source={1}
												kids={true}
											/>
										</td>
										<td>
											<span>660 DKK</span>
										</td>
										<td>x1-2</td>
										<td>{t('prices.table.lifelong')}</td>
									</tr>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={t('vaccines.mumps.title')}
												vaccine='mumps'
												what_is={1}
												can_be_vaccinated={2}
												source={1}
												kids={true}
											/>
										</td>
										<td>
											<span>660 DKK</span>
										</td>
										<td>x1-2</td>
										<td>{t('prices.table.lifelong')}</td>
									</tr>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={t('vaccines.rubella.title')}
												vaccine='rubella'
												what_is={2}
												can_be_vaccinated={2}
												occurrence={1}
												source={2}
												kids={true}
											/>
										</td>
										<td>
											<span>660 DKK</span>
										</td>
										<td>x1-2</td>
										<td>{t('prices.table.lifelong')}</td>
									</tr>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={t('vaccines.chicken_pox.title')}
												vaccine='chicken_pox'
												what_is={4}
												can_be_vaccinated={3}
												protection={1}
												occurrence={1}
												source={2}
												kids={true}
											/>
										</td>
										<td>
											<span>600 DKK</span>
										</td>
										<td>x2</td>
										<td>1-2 {t('prices.table.months')}</td>
									</tr>
									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={`${t('vaccines.tuberculosis.title')} (BCG) ${t(
													'prices.table.text7'
												)}`}
												vaccine='tuberculosis'
												what_is={1}
												can_be_vaccinated={2}
												occurrence={1}
												source={1}
												kids={true}
											/>
										</td>
										<td>
											<span>620 DKK</span>
										</td>
										<td>x1</td>
										<td>{t('prices.table.lifelong1')}</td>
									</tr>
									<tr>
										<td className='text-uppercase'>
											<BasicLink route='/narco-test ' title={`${t('navbar.narcotest')} multi`} />
										</td>
										<td>
											<span>690 DKK</span>
										</td>
										<td>x1</td>
										<td>{t('coronatest.text27')}</td>
									</tr>

									<tr>
										<td>
											<BasicVaccineLink
												more={true}
												title={t('prices.table.text2')}
												vaccine='malaria'
												what_is={2}
												protection={5}
												occurrence={2}
												source={1}
											/>
										</td>
										<td>
											<span>110 DKK</span>
										</td>

										<td />
										<td></td>
									</tr>
								</tbody>
							</Table>
							<Booking />

							{/* <h3 className='page_subtext text-uppercase pt-5'>
                {t('prices.title3')}
              </h3>
              <p>
                {t('prices.text10')}
                <a
                  className='country_links inline'
                  title='E-mail klinik@rcscanning.com'
                  rel='external nofollow noopener'
                  target='_blank'
                  href='mailto:klinik@rcscanning.com'
                >
                  klinik@rcscanning.com
                </a>
                . {t('prices.text11')}
              </p> */}
							{/* <Table responsive striped>
                <thead className='page_subtext text-uppercase'>
                  <tr>
                    <td>{t('prices.table.title')}</td>
                    <td>{t('prices.table.title1')}</td>
                    <td>{t('prices.table.title2')}</td>
                    <td>{t('prices.table.title3')}</td>
                  </tr>
                </thead>
                <tbody></tbody>
              </Table> */}
						</article>
					</Container>
				</BasePage>
			</BaseLayout>
		</React.Fragment>
	);
};
export default translate(Prices);
